// Legacy Firebase products utilities - now using centralized service
// This file is kept for backward compatibility
// New code should use src/services/firestore.js instead

import { 
  getProducts, 
  addProduct, 
  getProductById, 
  updateProduct, 
  deleteProduct,
  getProductsByCategory,
  searchProductsByName,
  getProductsWithPagination,
  clearProductsCache,
  getCacheStatus
} from '../services/firestore';

// Legacy function names for backward compatibility
export const getAllProducts = getProducts;
export const createProductData = (name, category, imageUrls, specs = {}, description = '') => {
  return {
    name,
    category,
    description,
    imageUrls: Array.isArray(imageUrls) ? imageUrls : [imageUrls],
    imageUrl: Array.isArray(imageUrls) ? imageUrls[0] : imageUrls,
    specs,
    createdAt: new Date(),
    updatedAt: new Date()
  };
};

// Re-export all functions from the centralized service
export {
  getProducts,
  addProduct,
  getProductById,
  updateProduct,
  deleteProduct,
  getProductsByCategory,
  searchProductsByName,
  getProductsWithPagination,
  clearProductsCache,
  getCacheStatus
}; 